import { ReadonlyDictionaryRepository } from '../abstraction';
import { IndexedDbDataAccess } from '../../data-access/indexed-db.data-access';
import { Dictionary } from '../../types/dictionary';

export abstract class ReadonlyIndexedDbDictionaryRepository<TItem, TParams extends Dictionary<any> | undefined> implements ReadonlyDictionaryRepository<Dictionary<TItem>, TParams> {

  protected constructor(protected dataAccess: IndexedDbDataAccess,
                        protected databaseName: string,
                        protected objectStoreName: string) { }

  async load(params: TParams): Promise<Dictionary<TItem>> {
    const response = await this.dataAccess.getAll<TItem>({
      databaseName: this.databaseName,
      objectStoreName: this.objectStoreName,
      params
    });
    return this.mapResponse(response);
  }

  protected abstract getKey(item: TItem): string;

  protected mapResponse(items: TItem[]): Dictionary<TItem> {
    const result: Dictionary<TItem> = {};
    for(const item of items) {
      const key = this.getKey(item);
      result[key] = item;
    }
    return result;
  }
}
